export const DEFAULT_CALCULATION_NUMBER = '0.00';
export const DEFAULT_MIN_DEBIT_CREDIT_NUMBER = 0;
export const DEFAULT_MIN_DEBIT_CREDIT_NUMBER_ON_BILLION = -1000000000000.0;
export const DEFAULT_MAX_DEBIT_CREDIT_NUMBER = 999999999999.99;
export const DEFAULT_EMPTY_CALCULATIONS_NUMBER = ['0.00', '0', '0.0'];
